module.exports = __webpack_public_path__ + "media/images/unlink-b8761030d4a17499149d2d61adc064b3.svg";